import React from "react";
import "../privacy/css/DeleteAccount.css";

const DeleteAccount = () => {
  return (
    <main className="form-container">
      <header>
        <h1>Delete Account Request</h1>
        <p>Please fill out the form to delete your account.</p>
      </header>

      <form action="delete_account_script.php" method="POST">
        <h2>Account Information</h2>
        <div className="input-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            required
            placeholder="Enter your email address"
          />
        </div>

        <div className="input-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            required
            placeholder="Enter your password"
          />
        </div>

        <div className="input-group">
          <label htmlFor="reason">Reason for Deleting Account</label>
          <textarea
            id="reason"
            name="reason"
            rows="4"
            placeholder="Please briefly tell us why you're deleting your account"
          ></textarea>
        </div>

        <button type="submit">Submit Deletion Request</button>

        <p className="warning">
          Warning: This action is permanent and cannot be undone. Your data will
          be permanently deleted from our records.
        </p>
      </form>
    </main>
  );
};

export default DeleteAccount;
